export const ageMethod = "age nearest";
export const gateway = "https://canary-quickterm-shopper-api.link.wawanesalife.com";
export const assets = "https://canary-assets.link.wawanesalife.com/brokers/wawanesalife";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3YXdhbmVzYWxpZmUiLCJuYW1lIjoid2F3YW5lc2FsaWZlIiwiaWF0IjoxNzUzNzk3NjkyLCJleHAiOjE5MTE1ODU2OTJ9.h469xZKbITIOaZhHksP9WVdBNvZlJ4-siDo-IAgUk-E";
export const brokerConfig = {
	enabled: "yes",
	authorized_nb: "yes",
	authorized_mb: "yes",
	authorized_pe: "yes",
	authorized_yt: "yes",
	authorized_sk: "yes",
	authorized_qc: "no",
	authorized_nt: "yes",
	authorized_nu: "yes",
	authorized_ns: "yes",
	authorized_nl: "yes",
	authorized_on: "yes",
	authorized_ab: "yes",
	authorized_bc: "yes",
	"split": '0.5'
};
export const brokerBranding = {
	"canary-quickterm-shopper.link.wawanesalife.com": {
		a: {
			environment: "canary",
			broker: "link_wawanesalife",
			website: "https://wawanesalife.com/",
			accessibilityLink: "https://www.wawanesa.com/canada/about-us/accessibility",
			tcLink: "https://www.wawanesalife.com/pip/terms-and-conditions.html",
			themeSwitcher: "show",
			broker_formatted_name: "Wawanesa Life",
			privacyLink: "https://www.wawanesalife.com/pip/privacy.html",
			layout: "corpo",
			scope: "wawanesalife#branding#canary-quickterm-shopper.link.wawanesalife.com#a",
			approve_company: "Link Platform",
			email: "lifeclient@wawanesa.com",
			g4: "GTM-PRVB33W3",
			photos: [
				"people1.jpg",
				"building1.jpg",
				"people2.jpg",
				"building2.jpg",
			],
			approve_user: "link_wawanesalife",
			logoPosition: "menu",
			environment_id: "canary",
			brands: [
				"canary-quickterm-shopper.link.wawanesalife.com",
			],
			"maps": {
				"AB branch": [
					"5008 86 Street NW",
					"Edmonton",
					"AB",
					"T6E 5S2",
				],
				"Head office": [
					"236 Carlton St",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
			},
			phone: "1-888-997-9965",
			menuPhone: "button",
			ab: "a",
			logo: "a.png",
			brand_name: "canary-quickterm-shopper.link.wawanesalife.com",
		},
		b: {
			environment: "canary",
			broker: "link_wawanesalife",
			website: "https://wawanesalife.com/",
			accessibilityLink: "https://www.wawanesa.com/canada/about-us/accessibility",
			tcLink: "https://www.wawanesalife.com/pip/terms-and-conditions.html",
			themeSwitcher: "show",
			broker_formatted_name: "Wawanesa Life",
			privacyLink: "https://www.wawanesalife.com/pip/privacy.html",
			layout: "corpo",
			scope: "wawanesalife#branding#canary-quickterm-shopper.link.wawanesalife.com#b",
			approve_company: "Link Platform",
			email: "lifeclient@wawanesa.com",
			g4: "GTM-PRVB33W3",
			photos: [
				"people1.jpg",
				"building1.jpg",
				"people2.jpg",
				"building2.jpg",
			],
			approve_user: "link_wawanesalife",
			logoPosition: "menu",
			environment_id: "canary",
			brands: [
				"canary-quickterm-shopper.link.wawanesalife.com",
			],
			"maps": {
				"AB branch": [
					"5008 86 Street NW",
					"Edmonton",
					"AB",
					"T6E 5S2",
				],
				"Head office": [
					"236 Carlton St",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
			},
			phone: "1-888-997-9965",
			menuPhone: "button",
			ab: "b",
			logo: "b.png",
			brand_name: "canary-quickterm-shopper.link.wawanesalife.com",
		},
	},
};

//updated on Tue Jul 29 2025 14:01:32 GMT+0000 (Coordinated Universal Time)
